import React from "react";

import MaterialDefault from './MaterialDefault'
import InputText from "./InputText";
import  sAction  from "sAction";
import Select from "./Select";
import Autocomplete from "./Autocomplete";

export default class Parent extends MaterialDefault {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      state: "fine",
      name: props?.data?.name,
      module: props?.data?.module,
      id: null,
      resultOpen: false,
      options: [],
      searchText: "",
    };
    this.input = React.createRef();
    this.autocomplete = React.createRef();
  }

  callAutocomplete = (keyCode) => {
    if(this.autocomplete?.current){
      this.autocomplete.current.keyUpHandler(keyCode);
    }
  }


  keyUp(event) {
    const keyCode = event.keyCode;    
    switch (keyCode) {
      case 38:
      case 40:
        this.callAutocomplete(keyCode)
        break;
      case 9:
        if (this.state.id !== "" || this.state.name === this.input.current.value) { //this.state.name
          super.onKeyDown(event, null, true);
        } else {
          //this.setState({keyCode: keyCode});
        }
        return;
        break;
      case 27:
        this.cancel();
        return;
        break;
      case 13:
        if(event.ctrlKey){
          return;
        }
        if (this.state.resultOpen == true) {
          this.callAutocomplete(keyCode);
        } else {
          //this.save();
        }
        return;
      break;
    }
    if (!this.input?.current?.value) {
      this.setState({resultOpen: false});
    } else {
      this.setState({searchText: this.input.current.value, resultOpen: true});
    }
  }

  selectItem(item, doUpdate = true,cancelEdit = true) {
    const parent = {
      id:item.id,
      name:item.name,
    }
    
    this.setState(parent);
    
    parent.module = this.state.module;

    this.props.callback(parent);
    
    this.input.current.value = item.name;
    
    this.cancel();
  }
  focus() {
    if (this.state.resultData != null) {
      this.setState({
        resultOpen: true
      });
    }
  }
  openPopupList() {
    var self = this;
    const data = {
      module: this.props.data.module,
      selectedActive: false,
      defaultFilter: this.props.defaultFilter
    };
    sAction.openRelatePopup(data, returnData => {
      self.selectItem(returnData);
      sAction.popupHide();
    });
  }
  chechChange(){
    if(this.state.value !== this.input.current.value){
        if (this.props.updateField == true) {
            this.input.current.value = '';
        } else {
            this.props.callback({name : this.input.current.value, id: this.state.id, module: this.state.module});
        }
    }
    this.cancel();
  }
  onBlur(e) {
    const relTarget = e.relatedTarget;

    if (relTarget == null) {
      this.chechChange();
    }
    else if (!(e.relatedTarget.className == "quickSearchResultLine")){
      this.chechChange();
    }
  }

  cancel(){
    this.setState({
      resultOpen: false
    });
  }
  
  moduleChange(val) {
    const item = {
      module: val,
      id: '',
      name: ''
    }
    this.setState(item);
    this.chechChange();
    this.props.callback(item);
  }
  
  getOptions() {

    sAction.load();
    sAction.getParentFieldOptions(this.props.module, returnData => {
      sAction.unLoad();
      var options = [];
      returnData.forEach(option => {
        options.push({
          value: option,
          label: sAction.app_strings["moduleList"][option]
        });
      });
      this.setState({
        options,
      });
      //sAction.dataSet(this.props.way + "/def/customOptions", options);
    });
    
  }
  
  componentDidMount(){
    this._isMounted = true;
    this.getOptions();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  storeRelate = (item) =>{
    if(item) {
      this.selectItem(item);
      this.setState({resultOpen: false});
      this.input.current.value = item.name;
    }
  }

  render() {
    const data = this.props.data;
    const newRecord = this.props.newRecord;
    var containerClassName = this.props.containerClassName ? this.props.containerClassName : null;
    var containerClass = "inputEditContainer " + containerClassName;

    var value = data.value;
    if (newRecord && (value === "" || value === undefined || value === null)) {
      value = "";
    }

    const containerClassField = "inputContainer relateField";

    var btnComp = [];
    //buttons={[{className: "detailInfoIcon",  onClick: this.prodInfo(data.id)}]}
    if(this.props.buttons != undefined){
      this.props.buttons.forEach(btn => {
        btnComp.push(<div
          key={btn.id}
          onClick={() => btn.onClick(btn.params)}
          className="inputEditButton"
        >
          <div className={btn.className} />
        </div>)
      });
    }
    return (
      <div className={containerClass} data-fieldname={data.name} style={this.props.containerStyle ? this.props.containerStyle : null}>
        <div className="detailViewParentModuleSelect">
          <Select
              onKeyDown={e => this.onKeyDown(e, "first")}
              options={this.state.options}
              onChange={e => this.moduleChange(e.target.value)}
              defaultValue={this.props.data.module}
              autoFocus={true}
          />
        </div>
        <div className={containerClassField}>
          <InputText
            onKeyDown={e => this.onKeyDown(e)}
            onKeyUp={event => this.keyUp(event)}
            onFocus={() => this.focus()}
            onBlur={e => this.onBlur(e)}
            myRef={this.input}
            id={data.name}
            defaultValue={value}
            label={this.props.data.label}
            InputProps={this.props.InputProps}
            error={this.props.error}
            autoFocus={this.props.autoFocus != undefined ? this.props.autoFocus : false}
            className={this.props.inputClassName ? this.props.inputClassName : null}
          />
          {this.state.resultOpen ? <Autocomplete
              data={data}
              resultOpen={this.state.resultOpen}
              searchText={this.state.searchText}
              defaultFilter={this.props.defaultFilter}
              searchMethod={"formParent"}
              autocompleteReturnItem={this.storeRelate}
              addButton={true}
              module={this.state.module}
              newRecord={this.newRecord}
              ref={this.autocomplete}
          /> : null}
        </div>
        {!newRecord && (
          <div className="buttonContainer">
            <div
              onClick={() => this.openPopupList()}
              className="inputEditButton openPopupButton"
            >
              {!this.props.hideSearchIcon && (<div className={"icon-search relateSearchIcon"} />)}
            </div>
            {btnComp}
          </div>
        )}
      </div>
    );
  }
}
